<template>
  <div
    class="mobile-device-frame"
    :class="[`device-${deviceSize}`]"
  >
    <!-- ノッチ/ステータスバー -->
    <div class="device-notch">
      <div class="notch-camera" />
    </div>

    <!-- コンテンツエリア -->
    <div
      class="device-screen"
      :style="screenStyle"
    >
      <slot />
    </div>

    <!-- ホームインジケーター -->
    <div class="device-home-indicator">
      <div class="home-bar" />
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

// デバイスサイズ定義
const DEVICE_SIZES = {
  mobile: { width: 390, height: 844 },
  tablet: { width: 820, height: 1180, landscape: true }, // iPad Air
}

export default {
  name: 'MobileDeviceFrame',

  props: {
    deviceSize: {
      type: String,
      default: 'mobile',
      validator: val => ['mobile', 'tablet'].includes(val),
    },
    backgroundColor: {
      type: String,
      default: '#1a1826',
    },
  },

  setup(props) {
    const screenStyle = computed(() => ({
      backgroundColor: props.backgroundColor,
    }))

    return {
      screenStyle,
    }
  },
}
</script>

<style scoped>
.mobile-device-frame {
  position: relative;
  background: linear-gradient(145deg, #2d2d2d, #1a1a1a);
  border-radius: 40px;
  padding: 12px;
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.5),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

/* モバイル（スマートフォン縦向き） */
.device-mobile {
  width: 414px;
}

.device-mobile .device-screen {
  width: 390px;
  height: 600px;
  max-height: 70vh;
}

/* タブレット（iPad Air 横向き - 820 x 1180 を縮小） */
.device-tablet {
  width: 680px;
  border-radius: 20px;
  padding: 10px;
}

.device-tablet .device-screen {
  width: 660px;
  height: 495px;
  border-radius: 12px;
}

.device-tablet .device-notch {
  display: none;
}

.device-tablet .device-home-indicator {
  height: 16px;
}

.device-tablet .home-bar {
  width: 100px;
  height: 3px;
}

/* ノッチ */
.device-notch {
  position: relative;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notch-camera {
  width: 80px;
  height: 24px;
  background: #0a0a0a;
  border-radius: 14px;
  position: relative;
}

.notch-camera::after {
  content: '';
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: #1a1a4a;
  border-radius: 50%;
}

/* スクリーン */
.device-screen {
  border-radius: 28px;
  overflow: hidden;
  position: relative;
}

/* ホームインジケーター */
.device-home-indicator {
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-bar {
  width: 120px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}
</style>
